import React, { useEffect, useState } from "react";
import "antd/dist/antd.css";
import {
  GeneralDefinition,
  ServicesTypesComponentLoad,
} from "../../types/ApplicationTypes";
import { Button, Row } from "@mtm/components";
import AddServiceuser from "../../assets/images/AddUser.png";
import MaybeLater from "../../assets/images/MaybeLater.png";
import Styles from "./AddAnotherServiceUser.module.scss";
import { useServiceUserCreationCtx } from "../../context/ServiceUserCreationContext";
import { useTripsCtx } from "../../context/TripDetailsContext";

type Props = {
  setPageType: Function;
  clearFields: boolean;
  setClearFields: Function;
  setIsLastEntered?: Function;
};

const AddAnotherServiceUser: React.FC<Props> = ({
  setPageType,
  clearFields,
  setClearFields,
  setIsLastEntered,
}) => {
  const [maxUserAdded, setMaxUserAdded] = useState<boolean>(false);
  const { serviceUsersCount } = useTripsCtx();
  const { whoWillUseServicesCtx } = useServiceUserCreationCtx();
  const [, setWhoWillUseServices] = whoWillUseServicesCtx;

  useEffect(() => {
    if (clearFields) {
      setClearFields(false);
      setPageType(ServicesTypesComponentLoad.SomeoneElseWillUseServices);
    }
  }, [clearFields]);

  function handleSuccess() {
    if (serviceUsersCount === 25) {
      setMaxUserAdded(true);
      return;
    }
    setIsLastEntered && setIsLastEntered(false);
    setWhoWillUseServices(GeneralDefinition.SomeoneElse);
    setPageType(ServicesTypesComponentLoad.SomeoneElseWillUseServices);
  }

  function handleCancel() {
    setPageType(ServicesTypesComponentLoad.WandaPlusSubscription);
  }

  return (
    <>
      <div className={Styles.AddAnotherService}>
        <p>Will you be scheduling services for anyone else?</p>
        <Row className={Styles.AddAnotherServiceRowGap}>
          <div className={Styles.AddAnotherServiceIconGap}>
            <img
              src={AddServiceuser}
              alt="AddServiceuser"
              className={Styles.AddAnotherServiceIconWidth}
            />
            <Button
              key="close"
              clickHandler={handleSuccess}
              className={
                maxUserAdded
                  ? "wandaBtnDisabled "
                  : "wandaBtnEnabled " + Styles.addButton
              }
              disabled={maxUserAdded}
            >
              Yes
            </Button>
            {maxUserAdded && (
              <div className="SpanPosition">
                <span className="subTextFont">Max Service Users added.</span>
              </div>
            )}
          </div>
          <div className={Styles.AddAnotherServiceIconGap}>
            <img
              src={MaybeLater}
              alt="MaybeLater"
              className={Styles.AddAnotherServiceIconWidth}
            />
            <Button
              key="close"
              clickHandler={handleCancel}
              className={Styles.maybeLaterbutton}
            >
              Maybe Later
            </Button>
          </div>
        </Row>
      </div>
    </>
  );
};
export default AddAnotherServiceUser;
